import { db, Timestamp } from '@/firebase.js'
import { firestoreAction } from 'vuexfire'
import { newId } from '@/utils'
import { DateTime } from 'luxon'

const getDefaultState = () => {
  return {
    data: [],
    ref: ''
  }
}

const state = getDefaultState()

const getters = {
  data(state) {
    return { ...state.data }
  },
  ref(state) {
    return state.ref
  },
  orders(state) {
    return Object.assign({}, ...state.data.map(i => ({ [i.id]: i })))
  },
  orderById(state) {
    return id => {
      return state.data.find(doc => doc.id === id)
    }
  }
}

const actions = {
  bindStore: firestoreAction(({ bindFirestoreRef, commit }, { storeId }) => {
    let ref = db
      .collection('stores')
      .doc(storeId)
      .collection('orders')
    commit('setRef', ref)
    return bindFirestoreRef(
      'data',
      ref.where(
        'date',
        '>=',
        DateTime.now()
          .minus({ days: 7 })
          .toJSDate()
      )
    )
  }),
  unbindStore: firestoreAction(({ unbindFirestoreRef }) => {
    unbindFirestoreRef('data')
  }),
  create: async function({ getters }, payload) {
    let id = newId()
    let now = Timestamp.now()
    let data = {
      updatedAt: now,
      createdAt: now,
      date: now,
      status: 'open',
      completed: false,
      id,
      ...payload
    }
    console.log('orders/create', id, data)
    return await getters.ref
      .doc(id)
      .set(data)
      .then(() => id)
      .catch(err => err)
  },
  delete: async function({ getters }, id) {
    console.log('orders/delete', id)
    if (!id) throw new Error('No ID provided.')
    return getters.ref.doc(id).delete()
  },
  save: async function({ dispatch }, { id, data }) {
    console.log('order/save', id, data)
    let now = Timestamp.now()
    return dispatch('updateItem', {
      id: id,
      data: {
        status: 'saved',
        updatedAt: now,
        completedAt: now,
        ...data
      }
    })
  },
  updateItem({ getters, rootGetters }, { id, data }) {
    console.log('orders/updateItem', id, data)
    return getters.ref.doc(id).update({
      ...data,
      updatedAt: Timestamp.now(),
      updatedBy: rootGetters['user/id']
    })
  },
  resetStoreState({ commit }) {
    commit('resetState', null)
  }
}

const mutations = {
  setRef(state, ref) {
    state.ref = ref
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  }
}

const orders = {
  namespaced: true,

  state,
  getters,
  mutations,
  actions
}

export default orders
